<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <div v-if="salesOrder == 'SalesOrder'">
      <v-layout wrap>
        <h2 class="black--text text-h5 font-weight-bold">Sales Orders</h2>
      </v-layout>
      <app-salesorder-table></app-salesorder-table>
    </div>
    <div v-if="salesOrder == 'InactiveSalesOrder'">
      <v-layout wrap>
        <h2 class="black--text text-h5 font-weight-bold">
          Inactive Sales Orders
        </h2>
      </v-layout>
      <inactive-sales-order />
    </div>
    <div v-if="salesOrder == 'InactiveSalesOrderCount'">
      <v-layout wrap>
        <h2 class="black--text text-h5 font-weight-bold">
          Inactive Sales Order Count
        </h2>
      </v-layout>
      <inactive-sales-order-count />
    </div>
    <div v-if="salesOrder == 'SalesOrderDayWise'">
      <v-layout wrap>
        <h2 class="black--text text-h5 font-weight-bold">
          Sales Order Day Wise
        </h2>
        <SalesOrderDayWiseTable />
      </v-layout>
    </div>
    <div v-if="salesOrder == 'SalesOrderDiscount'">
      <v-layout wrap>
        <h2 class="black--text text-h5 font-weight-bold">
          Sales Order Discount
        </h2>
        <SalesOrderDiscount />
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import SalesOrderTable from "../components/SalesOrderTable.vue";
import SalesOrderDayWiseTable from "../components/SalesOrderDayWiseTable.vue";
import SalesOrderDiscount from "../components/SalesOrderDiscount.vue";
import InactiveSalesOrder from "../components/inactiveSalesOrder.vue";
import InactiveSalesOrderCount from "../components/CountInactiveSalesOrder.vue";
export default {
  components: {
    "app-salesorder-table": SalesOrderTable,
    SalesOrderDayWiseTable,
    SalesOrderDiscount,
    InactiveSalesOrder,
    InactiveSalesOrderCount
  },
  data() {
    return {
      salesOrder: "",
      routeName: "",
      startDate: "",
      endDate: "",
      textFields: [],
      tags: [],
      variables: {
        limit: 25,
        skip: 0
      },
      loading: true,
      areaList: null,
      totalItemsCount: null,
      area: {
        NameEn: "",
        NameAr: ""
      }
    };
  },
  created() {
    if (
      !this.hasRole(this.AdminUserPermissions.SALES_ORDER_VIEW) &&
      !this.hasRole(this.AdminUserPermissions.SALES_ORDER_DAY_WISE_VIEW)
    ) {
      this.$router.push({
        name: "Error404"
      });
    } else {
      this.routeName = this.$route.name;
      this.routePage();
    }
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.routeName = this.$route.name;
      this.routePage();
    },
    routePage() {
      this.salesOrder = this.routeName;
    }
  }
};
</script>
